import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { OtpInput } from './OtpInput';
import { OtpVerifyButton } from './OtpVerifyButton';
import { MfaInputBaseProps } from './type';

interface Props extends MfaInputBaseProps {}

export const TotpOtpInput = ({ label, description, verified, loading, length = 6, onSubmit }: Props) => {
  const t = useTranslations();
  const { valueAtom, errorMessageAtom, onChange } = useBunja(totpOtpBunja);
  const value = useAtomValue(valueAtom);
  const errorMessage = useAtomValue(errorMessageAtom);

  const handleChange = (code: string) => {
    onChange(code);
    if (code.length === length) onSubmit?.('totp', code);
  };

  return (
    <OtpInput
      channel='totp'
      value={value}
      errorMessage={errorMessage}
      length={length}
      label={label ?? t('Common.r250912.Authenticator_code')}
      description={description ?? t('Mfa_verify.r250912.Authenticator_instruction')}
      disabled={verified || loading}
      action={<OtpVerifyButton loading={loading} verified={verified} />}
      onChange={handleChange}
    />
  );
};

export const totpOtpBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const valueAtom = atom('');
  const errorMessageAtom = atom('');

  function onChange(value: string): void {
    store.set(valueAtom, value);
    store.set(errorMessageAtom, '');
  }

  function setError(message: string): void {
    store.set(errorMessageAtom, message);
  }

  function clear(): void {
    store.set(valueAtom, '');
    store.set(errorMessageAtom, '');
  }

  return {
    valueAtom,
    errorMessageAtom,
    onChange,
    setError,
    clear,
  };
});

totpOtpBunja.debugLabel = 'totpOtpBunja';
